import { Routes, Route } from "react-router-dom"

import Home from "../pages/Home"
import Categories from "../pages/Categories"
import Products from "../pages/Products"
import About from "../pages/About"
import Contact from "../pages/Contact"
import ProductDetails from "../pages/ProductDetails"
import CategoryDetails from "../pages/CategoryDetails"
import PrivacyPolicy from "../pages/PrivacyPolicy"
import TermsConditions from "../pages/TermsConditions"

function NotFound() {
  return (
    <section className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-gray-900">
          404
        </h1>

        <p className="mt-4 text-gray-600">
          La page demandée est introuvable.
        </p>
      </div>
    </section>
  )
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={<Home />}
      />

      <Route
        path="/categories"
        element={<Categories />}
      />
<Route
  path="/categories/:slug"
  element={<CategoryDetails />}
/>
      <Route
        path="/produits"
        element={<Products />}
      />
<Route
  path="/produits/:slug"
  element={<ProductDetails />}
/>
      <Route
        path="/a-propos"
        element={<About />}
      />

      <Route
        path="/contact"
        element={<Contact />}
      />

      <Route
        path="*"
        element={<NotFound />}
      />
      <Route
  path="/politique-confidentialite"
  element={<PrivacyPolicy />}
/>

<Route
  path="/conditions-generales"
  element={<TermsConditions />}
/>
    </Routes>
  )
}